<script setup lang="ts">
  import { Check, Plus, Users } from 'lucide-vue-next';
  import { storeToRefs } from 'pinia';
  import { useFormPermissionsSelectionStore } from '../../model/form-permissions-selection.store';

  withDefaults(defineProps<{ disabled?: boolean }>(), { disabled: false });

  const selectionStore = useFormPermissionsSelectionStore();
  const { addMode } = storeToRefs(selectionStore);
</script>

<template>
  <section class="flex flex-col gap-4" data-testid="permissions-add-section">
    <header class="flex h-[42px] items-center gap-2 border-b border-gray-03 p-2">
      <span
        class="flex h-6.5 w-6.5 shrink-0 items-center justify-center rounded-sm bg-[var(--theme-secondary)]"
      >
        <Users class="size-4 text-[var(--theme-on-secondary)]" aria-hidden="true" />
      </span>
      <h2 class="text-sm font-medium text-gray-07">Adicionar Permissões</h2>
    </header>

    <div
      class="flex flex-col gap-2 rounded-lg border p-4"
      :class="addMode ? 'border-[var(--theme-secondary-ink)]' : 'border-gray-02'"
      data-testid="permissions-add-card"
    >
      <div class="flex items-start justify-between gap-2">
        <h3 class="text-sm font-medium text-gray-07">Seleção de campos</h3>
        <div class="flex shrink-0 items-center gap-1">
          <button
            v-tippy="{ content: 'Adicionar campos', placement: 'top', theme: 'custom' }"
            type="button"
            class="flex size-5 items-center justify-center rounded-sm"
            :class="
              addMode || disabled
                ? 'cursor-not-allowed bg-gray-02 text-gray-05'
                : 'bg-[var(--theme-secondary)] text-white'
            "
            aria-label="Adicionar campos"
            :disabled="addMode || disabled"
            data-testid="permissions-add-fields-btn"
            @click="selectionStore.startAdd()"
          >
            <Plus class="size-4" aria-hidden="true" />
          </button>
          <button
            v-tippy="{ content: 'Confirmar', placement: 'top', theme: 'custom' }"
            type="button"
            class="flex size-5 items-center justify-center rounded-sm"
            :class="
              addMode
                ? 'bg-[var(--theme-secondary)] text-white'
                : 'cursor-not-allowed bg-gray-02 text-gray-05'
            "
            aria-label="Confirmar"
            :disabled="!addMode"
            data-testid="permissions-confirm-fields-btn"
            @click="selectionStore.confirm()"
          >
            <Check class="size-4" aria-hidden="true" />
          </button>
        </div>
      </div>
      <p class="text-xs text-gray-05">
        Clique no ícone de +, então selecione os campos que devem receber a permissão. Quando
        concluir, clique no "check" para finalizar.
      </p>
    </div>
  </section>
</template>
